/** 本番の基本サンプル率（トレース・プロファイルの母数） */
export const DEFAULT_TRACES_SAMPLE_RATE = 0.01;
/** 1 日の遷移が少なく 1% では日次 p75 が安定しない画面に使う率 */
export const BOOSTED_TRACES_SAMPLE_RATE = 0.1;

/**
 * 率を上げる画面（Sentry の navigation span 名 = TanStack Router の routeId）。
 * 2026-10-06 時点の 1 日あたり実サンプル: 購入 11・オンボーディング 17・ビデオ通話中 29・ビデオ発信 42・デイリーボーナス 55。
 */
export const BOOSTED_NAVIGATION_ROUTE_IDS: ReadonlySet<string> = new Set([
  "/_authenticated/purchase",
  "/_authenticated/daily-bonus",
  "/_authenticated/onboarding/",
  "/_authenticated/call/video/",
  "/_authenticated/call/video/outgoing",
  "/_authenticated/call/audio/",
  "/_authenticated/call/audio/outgoing",
]);

type SamplingContext = {
  name: string;
  attributes?: Record<string, unknown>;
  inheritOrSampleWith: (fallbackSampleRate: number) => number;
};

/** Sentry.init の tracesSampler。開発ビルドは全件 */
export const createTracesSampler =
  (isProd: boolean) =>
  (ctx: SamplingContext): number => {
    if (!isProd) return 1.0;
    if (
      ctx.attributes?.["sentry.op"] === "navigation" &&
      BOOSTED_NAVIGATION_ROUTE_IDS.has(ctx.name)
    ) {
      return BOOSTED_TRACES_SAMPLE_RATE;
    }
    return ctx.inheritOrSampleWith(DEFAULT_TRACES_SAMPLE_RATE);
  };

export const tracesSampler = createTracesSampler(import.meta.env.PROD);
